// Valores de estadoPagoId retornados por Sisad
export const sisadEstadoPagoEnum = {
    INICIADO: 1,
    EN_PROCESO: 2,
    PAGADO: 3,
    PARCIALMENTE_PAGADO: 4,
    RECHAZADO: 5,
    ANULADO: 6,
}
